var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#78909C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.635l-1.249-1.12-1.249 1.12",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.635l-1.249-1.12-1.249 1.12M12.001 17.21v-5.604M7.772 15.092l.458-1.529-1.707-.414M6.594 14.408l5.408-2.803M6.523 10.063l1.703-.412-.454-1.532M6.594 8.803l5.408 2.802M10.752 6.576l1.245 1.117 1.253-1.117M12.001 6v5.605M16.227 8.12l-.454 1.528 1.703.415M17.41 8.803l-5.408 2.803M17.476 13.149l-1.703.407.454 1.536M17.41 14.409l-5.408-2.803",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleSnowflake);
export default __webpack_public_path__ + "static/media/bubble-snowflake.ec0dee5f.svg";
export { ForwardRef as ReactComponent };